module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DARKNESS RISING")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0032-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3d#hc7",
      "id": "ch7"
    }
  }, [_vm._v("4. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0032-02-1"
    }
  }, [_c('span', [_vm._v("Dani was shocked when she read a text message from Carl Thorstein telling her Abbie Gardener had passed away in the night. Carl was a friend of Tommy’s, a theologian and scholar who’d counseled Tommy after that tragic accident convinced him to do something other than play football. Carl often visited residents at High Ridge Manor, the nursing home where Abbie had been a resident. According to Carl, Abbie had been alive during a routine bed check at ten and dead at the next check at two.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-2"
    }
  }, [_c('span', [_vm._v("Dani put a kettle of water on the stove for tea, then texted Tommy the news. He instantly texted her back: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("I HEARD. INTERESTING TIMING")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-3"
    }
  }, [_c('span', [_vm._v("She’d been thinking the same thing. She typed back: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FIGURED HE TOLD YOU. NATURAL CAUSES, RIGHT? CARL SAID IN HER SLEEP")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-4"
    }
  }, [_c('span', [_vm._v("She’d barely set the phone back down when Tommy’s response popped onto her screen: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN THE NIGHT. BIG DIFFERENCE")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-5"
    }
  }, [_c('span', [_vm._v("Dani reread Carl’s text and realized Tommy was right. She sent him one more: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("I")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL MAKE SOME CALLS")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-6"
    }
  }, [_c('span', [_vm._v("Dani had questioned Tommy’s run-in with Dr. Ghieri because she was skeptical by nature. When he’d told her Ghieri had lifted him off the ground, she reasoned that Ghieri was a strong man temporarily assisted by a jolt of adrenaline. She thought it more likely the guidance counselor had “vanished” simply by running from the room while Tommy was still on the"), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v(" floor, recovering from being choked. Charlie wasn’t an angel; he was simply a guest at the opening who had appeared to help Tommy because he’d heard the scuffle. She didn’t believe in prophecies or premonitions—she knew that if you had a thousand premonitions a day, you’d only pay attention to the one that came true and forget the other nine hundred and ninety-nine.")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('span', [_vm._v("But when Tommy told her Charlie had produced a flaming sword and provided a demonstration of its power, she did not doubt him but sought corroboration. After he dropped her off at home, she’d researched the notion of angels wielding swords and had found plenty of references in the Bible and in noncanonical texts.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-01-1"
    }
  }, [_c('span', [_vm._v("“You "), _c('i', [_vm._v("should ")]), _vm._v("be asking questions,” Tommy had said. “God wants you to ask questions—he wants you to be "), _c('i', [_vm._v("you")]), _vm._v(", and to use all your scientific training. Test your hypotheses and don’t take things at face value. That’s what you do, and you’re good at it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-01-2"
    }
  }, [_c('span', [_vm._v("Following Tommy’s line of thinking, however, required a leap of faith. Dani had made the leap when she realized science couldn’t explain the things that were happening. On the night Julie Leonard was killed, Dani had begun having troubling dreams that woke her at exactly 2:13 night after night. Then Tommy reported having the exact same dream she’d had, an apocalyptic nightmare where millions of people were fleeing a flooded city and jumping to their deaths from tall white buildings. Then an angel had spoken to her—in a dream, but she knew it was real. He’d said, “Go ahead and jump—I’m here to catch you if you need me.” The angel had spoken to Tommy too, and told him to look in the book of Revelation, chapter 2, verse 13: "), _c('i', [_vm._v("“I know where you dwell, where Satan’s throne is; and you hold fast My name . . . My witness, My faithful one, who was killed among you, where Satan dwells.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-01-3"
    }
  }, [_c('span', [_vm._v("Tommy’s conclusion was that God wanted them to be together. He’d sent them an angel to tell them Satan was at work somewhere in the town where they lived, East Salem, and God wanted them to do something about it. Dani couldn’t argue.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("She and Tommy had decided to do what each did best, a kind of division of labor. God had brought them back together and given them an assignment, a part to play in a spiritual war, the breadth and scope of which were beyond their knowing. They agreed that Dani would approach things scientifically, using her medical training and psychiatric expertise, while Tommy would pursue the more spiritual lines of inquiry.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-1"
    }
  }, [_c('span', [_vm._v("She sat down at her kitchen table to sip her tea and think.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-2"
    }
  }, [_c('span', [_vm._v("Tommy was right about the timing. Abbie Gardener died the very night the Bosch exhibition opened at St. Adrian’s. After all the strange things that had happened in East Salem recently, Dani was inclined to believe that if something seemed suspicious or evil, it probably was.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-3"
    }
  }, [_c('span', [_vm._v("Why that night? For over a century, before succumbing to Alzheimer’s, Abbie had lived on a 150-acre farm that included half a mile of frontage on Lake Atticus. Abbie drove her own car, worked in the town archives, and stayed active until she was 100, declining an invitation from the mayor for a town-wide birthday party. Her son, George, brought her to High Ridge Manor at the age of 101, when he’d realized she was failing and he could no longer keep her from wandering off the property. If she’d lived so long, why die the very night the painting came to town? What was the connection?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-4"
    }
  }, [_c('span', [_vm._v("Dani went to her study and looked on the shelves where she kept books she’d treasured as a child. Among them she found what she was looking for, a slender volume entitled "), _c('i', [_vm._v("The Witches of East Salem ")]), _vm._v("by Abigail Gardener. She leafed through it but found nothing remarkable save the title page, where the author had written during a visit to Dani’s fourth-grade class, "), _c('i', [_vm._v("You are special")]), _vm._v(".")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-01-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Tommy and Dani still wondered if Abbie was somehow connected to the murder on Bull’s Rock Hill. The night Julie Leonard died, Abbie had wandered away from the nursing home and managed to set off the alarm on Tommy’s property at two in the morning. Tommy found her by his pond, where she insisted on showing him a dead frog she held in her hands. “These are the first,” she’d told Tommy. “You’ll be the last.” She’d seemed incoherent, rambling about luck’s fairy, they thought, until Carl Thorstein")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v(" realized she’d been speaking Latin. “Luck’s fairy” was in fact "), _c('i', [_vm._v("lux ferre")]), _vm._v(", which translated as “light-bringer,” the Latin root for the name Lucifer.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-1"
    }
  }, [_c('span', [_vm._v("It placed her in proximity to the killing, if nothing else.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-2"
    }
  }, [_c('span', [_vm._v("Tommy had met with Abbie in the nursing home a few days later, hoping she’d seen something the night Julie died. He’d had Carl record the interview, which hadn’t gone well—a few semi-cogent responses, and then the old woman transitioned into a psychogenic fugue.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-3"
    }
  }, [_c('span', [_vm._v("Dani looked out the window of her study. The morning sky was dark gray and heavy with the promise of rain. With the leaves all down on an overcast November day, the town of East Salem took on a sepulchral tone, the massive homes and mansions suddenly visible through the naked trees, and they looked gloomy and lonely, isolated from each other. Once the Christmas lights went up in December, things would be cheerier, assuming the town could shake the additional pall cast by the recent tragedies. People were still on edge. Parents hugged their kids just a little harder, tucked them in just a little tighter, checked to make sure the doors and windows were all locked before going to bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-4"
    }
  }, [_c('span', [_vm._v("Dani picked up the phone to call Stuart Metz, the assistant DA. She’d dialed the first three numbers when her cell phone rang. She glanced at her caller ID.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-5"
    }
  }, [_c('span', [_vm._v("“Stuart,” she said. “I was just about to call you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-6"
    }
  }, [_c('span', [_vm._v("“You heard?” Metz said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-7"
    }
  }, [_c('span', [_vm._v("“About Abbie Gardener?” Dani said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-8"
    }
  }, [_c('span', [_vm._v("“They took the body straight to the medical examiner. He said he’s never seen anything like it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-9"
    }
  }, [_c('span', [_vm._v("“What does that mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-10"
    }
  }, [_c('span', [_vm._v("“I don’t know. Just telling you what Banerjee said. How soon can you be there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-11"
    }
  }, [_c('span', [_vm._v("“They need me?”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“Casey asked for you,” Metz said. Detective Philip Casey had been the lead detective on the Leonard murder. “If you’re feeling up to it. I know")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v(" you’re still on leave, but this is just a little consulting. I think he has some questions about Alzheimer’s.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-01-1"
    }
  }, [_c('span', [_vm._v("“I never evaluated Abbie,” Dani said. “There must be someone at the nursing home who knows more about her condition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-01-2"
    }
  }, [_c('span', [_vm._v("“Yeah, but you’re on the payroll.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-01-3"
    }
  }, [_c('span', [_vm._v("“I’ll be there in thirty minutes. Forty with traffic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-01-4"
    }
  }, [_c('span', [_vm._v("The county medical examiner had never seen anything like it? Baldev Banerjee had seen a great deal. Dani wasn’t sure she wanted to see what had happened to Abigail Gardener. She’d been a brave soul who deserved a peaceful ending. Dani doubted she’d gotten one.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607d5660","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter7.vue
// module id = 90
// module chunks = 0